import { PaginadoNotificaciones } from '../../pages/notificaciones/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const notificacionesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Lista notificaciones en orden descendente por fecha de creacion.
     * `forceRefetch` permite cargar paginas nuevas aunque RTK Query tenga cache previo.
     */
    recuperarNotificaciones: builder.query<PaginadoNotificaciones, { pagina: number }>({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_NOTIFICACIONES}/?columna=fecha_creacion&ordenar=DESC&registros_por_pagina=15`,
          params: keysToSnake(arg),
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg
      },
    }),
    /**
     * Actualiza el estado de una notificacion individual, por ejemplo marcarla como leida.
     */
    actualizarNotificacion: builder.mutation({
      query: ({ idNotificacion, ...notificacion }) => {
        return {
          url: `${window._env_.API_CONTEXTO_NOTIFICACIONES}/${idNotificacion}`,
          method: 'PUT',
          body: keysToSnake(notificacion),
        }
      },
    }),

    /**
     * Actualiza varias notificaciones en lote desde el endpoint de estado.
     */
    actualizarNotificaciones: builder.mutation({
      query: (notificaciones) => {
        return {
          url: `${window._env_.API_CONTEXTO_NOTIFICACIONES}/status`,
          method: 'PUT',
          body: keysToSnake(notificaciones),
        }
      },
    }),
  }),
})

export const {
  useRecuperarNotificacionesQuery,
  useActualizarNotificacionMutation,
  useActualizarNotificacionesMutation,
} = notificacionesApi
